'use client'

import { LocalizedLink } from '../LocalizedLink/LocalizedLink'
import { imageCardDefaults } from './ImageCard.defaults'
import { type ImageCardProps } from './ImageCard.props'

export const ImageCard = (props: ImageCardProps = imageCardDefaults) => {
  const {
    heading,
    subheading,
    imageSrc,
    redirectUrl,
    headingColor,
    subheadingColor,
    showGradient,
  } = props

  const Wrapper = redirectUrl ? LocalizedLink : 'div'

  return (
    <Wrapper
      className="flex h-[490px] flex-col rounded-[32px] bg-cover bg-center bg-no-repeat px-4 py-8 lg:h-[700px] lg:p-16"
      style={{
        backgroundImage: `${showGradient ? 'linear-gradient(180deg, rgba(0,0,0,0) 52.41%, #000000 100%), ' : ''}url(${imageSrc})`,
      }}
      href={redirectUrl ?? ''}
    >
      <div className="mt-auto">
        <h6
          className="text-heading-display-3 mb-1"
          style={{ color: headingColor }}
          dangerouslySetInnerHTML={{ __html: heading ?? '' }}
        ></h6>
        <p
          className="text-body-md"
          style={{ color: subheadingColor }}
          dangerouslySetInnerHTML={{ __html: subheading ?? '' }}
        ></p>
      </div>
    </Wrapper>
  )
}
